import { EnumBadge } from '@mxa-argos/components/custom/enum-badge';
import { IconLabel } from '@mxa-argos/components/custom/icon-label';
import { SearchItemLayout } from '@mxa-argos/modules/search/components/search-item-layout';
import type { SearchResult } from '@mxa-argos/modules/search/hooks/use-resource-search';
import { Factory, Smartphone } from 'lucide-react';

interface Props {
  result: SearchResult;
}

export function DeviceSearchItem({ result }: Props) {
  return (
    <SearchItemLayout
      icon={Smartphone}
      primary={result.primary}
      secondary={
        result.secondary && <EnumBadge enumName="DeviceStatus" value={result.secondary} size="sm" />
      }
      tertiary={result.tertiary}
      quaternary={result.quaternary && <IconLabel icon={Factory} value={result.quaternary} />}
    />
  );
}
